import { Link } from 'react-router-dom';
import { Home, PanelLeftClose, PanelLeftOpen } from 'lucide-react';
import { Button } from '@/components/ui/button';
import LanguageSwitcher from '@/components/header/LanguageSwitcher';
import { ThemeToggle } from '@/components/header/ThemeToggle';
import UserNav from '@/components/header/UserNav';
import { useTranslation } from 'react-i18next';

interface AdminHeaderProps {
  isMobile: boolean;
  onToggleSidebar: () => void;
  sidebarOpen: boolean;
}

const AdminHeader = ({
  isMobile,
  onToggleSidebar,
  sidebarOpen
}: AdminHeaderProps) => {
  const { t } = useTranslation();
  const toggleLabel = sidebarOpen
    ? t('admin.closeSidebar', 'Close sidebar')
    : t('admin.openSidebar', 'Open sidebar');

  return (
    <header className="sticky top-0 z-10 flex h-16 shrink-0 items-center justify-between border-b border-border bg-card px-6">
      <div className="flex items-center gap-4">
        <Button
          aria-expanded={sidebarOpen}
          aria-label={toggleLabel}
          className="fongpt-hover rounded-lg text-muted-foreground"
          variant="ghost"
          size="icon"
          onClick={onToggleSidebar}
          title={toggleLabel}
        >
          {sidebarOpen ? (
            <PanelLeftClose className="h-5 w-5" />
          ) : (
            <PanelLeftOpen className="h-5 w-5" />
          )}
        </Button>
        {isMobile ? (
          <h1 className="text-xl font-bold">
            {t('admin.title', 'Admin Panel')}
          </h1>
        ) : null}
      </div>

      <div className="flex items-center gap-3">
        <Link to="/">
          <Button
            variant="ghost"
            size="icon"
            title={t('admin.backToChat', 'Back to Chat')}
          >
            <Home className="h-5 w-5" />
          </Button>
        </Link>
        <LanguageSwitcher />
        <ThemeToggle />
        <UserNav />
      </div>
    </header>
  );
};

export default AdminHeader;
